import Router from 'vue-router';
let LessonList = (resolve) => require(['../page/lesson/lessonList.vue'],resolve);
let BankList =(resolve) => require(['../page/bank/bankList.vue'],resolve);
let ExerciseList =(resolve) => require(['../page/exercise/exerciseList.vue'],resolve);
let Personal =(resolve) => require(['../page/personal/personal.vue'],resolve);
let Lessondetail =(resolve) => require(['../page/lesson/lessondetail.vue'],resolve);
let Lessonexercise =(resolve) => require(['../page/lesson/lessonexercise.vue'],resolve);

let TeacherLessonList =(resolve) => require(['../page/teacher/lesson/lessonList.vue'],resolve);
let ProblemBank =(resolve) => require(['../page/teacher/lesson/problemBank.vue'],resolve);

let QuestionList =(resolve) => require(['../page/teacher/question/questionlist.vue'],resolve);
let NewQuestion =(resolve) => require(['../page/teacher/question/newquestion.vue'],resolve);
let QuestionProblemSubmissions =(resolve) => require(['../page/teacher/question/questionProblemSubmissions.vue'],resolve);
let TeacherQuestionPreview =(resolve) => require(['../page/teacher/question/markdownPreview.js'],resolve);

let TeacherExerciseList =(resolve) => require(['../page/teacher/exercise/exerciseList.vue'],resolve);
let TeacherExerciseDetail =(resolve) => require(['../page/teacher/exercise/exercisedetail.vue'],resolve);
let TeacherNewExercise =(resolve) => require(['../page/teacher/exercise/newexercise.vue'],resolve);
let TeacherExerciseRanking =(resolve) => require(['../page/teacher/exercise/exerciseRanking.vue'],resolve);

let MemberPass =(resolve) => require(['../page/teacher/member/memberpass.vue'],resolve);
let MemberUnpass =(resolve) => require(['../page/teacher/member/memberunpass.vue'],resolve);
let MemberAdd =(resolve) => require(['../page/teacher/member/memberadd.vue'],resolve);

let TeacherNewLesson =(resolve) => require(['../page/teacher/lesson/newlesson.vue'],resolve);
let TeacherLessonIpRecords =(resolve) => require(['../page/teacher/lesson/lessonIpRecords.vue'],resolve);

let TeacherResources =(resolve) => require(['../page/teacher/resources/resources'],resolve);
let ExperimentalReport =(resolve) => require(['../page/teacher/experimentalReport/experimentalReport'],resolve);
let NewReport =(resolve) => require(['../page/teacher/experimentalReport/newReport'],resolve);
let submitReport =(resolve) => require(['../page/lesson/submitReport'],resolve);
let studentSubmitReport =(resolve) => require(['../page/teacher/experimentalReport/studentSubmitReport'],resolve);
let studentSubmitReportDetail =(resolve) => require(['../page/teacher/experimentalReport/studentSubmitReportDetail'],resolve);

let TeacherList = (resolve) => require(['../page/teacherList/teacherList'],resolve);


// import Login from '../page/login/login.vue'
let Login = (resolve) => require(['../page/login/login.vue'],resolve);
let Regist = (resolve) => require(['../page/login/regist.vue'],resolve);

let Home =  (resolve) => require(['../page/home/home.vue'],resolve);

import remind from '@/network/remind';

Vue.use(Router)

const routes = [
  {
    path: '',
    //重定向，默认的首页
    //redirect: '/login'
    redirect: '/login'
  },
  {
    path: '/login',
    name:'Login',
    // component: Login,
    component: Login,
  },
  {
    path: '/teacher/login',
    name:'Login',
    component: Login,

  },
  {
    path: '/regist',
    name: 'Regist',
    component: Regist,

  },
  {
    path: '/teacher/regist',
    name: 'Regist',
    component: Regist,

  },
  {
    path: '/teacherHome',
    name: 'Home',
    component: Home,
    children:[
      {
        path: '',
        name: 'TeacherLessonList',
        component: TeacherLessonList
      },
      {
        path: 'lessonList',
        component: TeacherLessonList,
        name: "TeacherLessonList"
      },
      {
        path: 'lessonList/lessondetail',
        component: TeacherNewLesson,
        name: 'TeacherNewLesson'
      },
      {
        path: 'lessonList/newLesson',
        component: TeacherNewLesson,
        name: 'TeacherNewLesson'
      },
      {
        path: 'problemBank',
        component: ProblemBank,
        name: 'ProblemBank'
      },
      {
        path: 'problemBank/detail',
        component: NewQuestion,
        name: 'ProblemBankDetail'
      },
      {
        path: 'questionlist',
        component: QuestionList,
        name: 'QuestionList'
      },
      {
        path: 'exerciseList',
        component: TeacherExerciseList,
        name: 'TeacherExerciseList'
      },
      {
        path: 'personal',
        component: Personal,
        name: 'personal'
      },
      {
        path: 'exerciseList/exercisedetail',
        component: TeacherExerciseDetail,
        name: 'TeacherExerciseDetail'
      },
      {
        path: 'exerciseList/newexercise',
        component: TeacherNewExercise,
        name: 'TeacherNewExercise'
      },
      {
        path: 'exerciseList/ranking',
        component: TeacherExerciseRanking,
        name: 'TeacherExerciseRanking'
      },
      {
        path: 'questionlist/questionDetail',
        component: NewQuestion,
        name: 'NewQuestion'
      },
      {
        path: 'questionlist/problemSubmissions',
        component: QuestionProblemSubmissions,
        name: 'QuestionProblemSubmissions'
      },
      {
        path: 'memberpass',
        component: MemberPass,
        name: 'MemberPass'
      },
      {
        path: 'memberunpass',
        component: MemberUnpass,
        name: 'MemberUnpass'
      },
      {
        path: 'memberadd',
        component: MemberAdd,
        name: 'MemberAdd'
      },
      {
        path: 'teacherResources',
        component: TeacherResources,
        name: 'resources'
      },
      {
        path: 'experimentalReport',
        component: ExperimentalReport,
        name: 'experimentalReport'
      },
      {
        path: 'newReport',
        component: NewReport,
        name: 'newReport'
      },
      {
        path: 'studentSubmitReport',
        component: studentSubmitReport,
        name: 'studentSubmitReport'
      },
      {
        path: 'submitReportScore',
        component: studentSubmitReportDetail,
        name:'studentSubmitReportDetail'
      },
      {
        path: 'teacherList',
        component: TeacherList,
        name: 'teacherList'
      },
      {
        path: 'lessonList/detail/exercise',
        name: "exercise",
        component: Lessonexercise,
      },
      {
        path: 'lessonList/ipRecords',
        component: TeacherLessonIpRecords,
        name: 'TeacherLessonIpRecords'
      },
    ]
  },
  {
    path: '/teacher/question-preview',
    name: 'TeacherQuestionPreview',
    component: TeacherQuestionPreview,
  },
  {
    path: '/studentHome',
    name:'Home',
    component: Home,
    children:[
      {
        path: '',
        name: 'lessonList',
        component: LessonList
      },
      {
        path: 'lessonList',
        name: 'lessonList',
        component: LessonList,

      },
      {
        path: 'lessonList/detail',
        name: "detail",
        component: Lessondetail,

      },
      {
        path: 'lessonList/detail/exercise',
        name: "exercise",
        component: Lessonexercise,
      },
      {
        path: 'bankList',
        name: 'bankList',
        component: BankList
      },
      {
        path: 'bankList/detail/exercise',
        component: Lessonexercise,
        name: 'exercise'
      },
      {
        path: 'exerciseList',
        component: ExerciseList,
        name: 'exerciseList'
      },
      {
        path: 'exerciseList/detail/exercise',
        component: Lessonexercise,
        name:'exercise'
      },
      {
        path: 'personal',
        component: Personal,
        name:'personal'
      },
      {
        path: 'lessonList/detail/submitReport',
        component: submitReport,
        name: 'submitReport'
      },
    ]
  },


]

const router = new Router({
  mode: "history",
  routes,
  //mode:'hash' //开发时使用
})

// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }


// router.beforeEach((to, from, next) => {
//   let user =this.$Decrypt(sessionStorage.getItem("userId"));
//   if (user || to.fullPath === "/login" || to.fullPath === "/teacher/login"||to.fullPath === "/teacher/regist"||to.fullPath === "/regist") {
//     next();
//   }
//   else {
//     remind.message("用户尚未登录", "error");
//     if (to.fullPath.includes('/teacher')) {
//       next({ path: '/teacher/login' });
//     } else {
//       next({ path: '/login' });
//     }
//   }
//
// });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js